// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.input-group.touched input[data-v-402c9ca2] {\n    border-color: rgb(220 38 38 / var(--tw-border-opacity));\n    --tw-border-opacity: 1\n}\n.input-group.touched label[data-v-402c9ca2] {\n    --tw-text-opacity: 1;\n    color: rgb(220 38 38 / var(--tw-text-opacity))\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
